import BuilderModel from "../../../../common/models/tracked/builderModel";
import PaymentStep from "./paymentStep";
import Vue from "vue";

export default class PaymentInvoice extends BuilderModel {
  from: string = '';
  bill_to: string = '';
  notes: string = '';

  constructor(paymentStep: PaymentStep, json: any = {}) {
    super();

    this.defineProperty('from', json['from'] || '');
    this.defineProperty('bill_to', json['bill_to'] || '');
    this.defineProperty('notes', json['notes'] || '');

    this.rootModel = paymentStep.rootModel;
    this.parent = paymentStep;
    Vue.set(paymentStep, 'payment_invoice', this);
  }
}